import React from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Calendar from './components/Calendar';

const AgendaAsignDayPage = (props) => {
  console.log(props.history.location.state);
  return (<Container className="dashboard">
            <Row>
              <Col md={12}>
                <h3 style={{ marginBottom: 30 }}>Generación de Agenda</h3>
              </Col>
            </Row>
            <Row>
                <Card>
                    <CardBody>
                        <Calendar dir={'direction'} events={[]} professional={props.history.location.state.professional} dayStartSelect={props.history.location.state.dayStartSelect} />
                    </CardBody>
                </Card>
            </Row>
        </Container>
)};

export default AgendaAsignDayPage;